import { useMemo, useRef } from 'react';

import { Document } from '@kanda-libs/ks-frontend-services';

import { BasePage, DESCRIPTION, TITLE } from './constants';

import { useOmniSignDocumentsContext } from '../../context';

export interface BaseDocument {
  name: string;
  content: string;
}

interface OmniSignDocumentsFormBasePageHook {
  title?: string;
  description?: string;
  document?: BaseDocument;
  scrollRef: React.MutableRefObject<HTMLDivElement | null>;
}

const getFilter = (page: BasePage): string => {
  if (page === 'preContact') return 'pre-contract';
  if (page === 'creditAgreement') return 'credit agreement';
  return 'direct debit';
};

export default function useOmniSignDocumentsFormBasePage(
  page: BasePage,
): OmniSignDocumentsFormBasePageHook {
  const { isFetching, documents } = useOmniSignDocumentsContext();

  const title = useMemo(() => TITLE[page], [page]);

  const description = useMemo(() => DESCRIPTION[page], [page]);

  const document = useMemo(() => {
    if (isFetching || !documents) return undefined;
    const filter = getFilter(page);
    const currentDocument = documents?.filter((doc: Document) =>
      doc.name.toLowerCase().includes(filter),
    )?.[0];
    if (!currentDocument || !currentDocument.content) return undefined;
    return {
      name: currentDocument.name,
      content: currentDocument.content,
    };
  }, [documents, isFetching, page]);

  const scrollRef = useRef<HTMLDivElement | null>(null);

  return {
    title,
    description,
    document,
    scrollRef,
  };
}
